import { defineStore } from "pinia";
import { Plan } from "@/stores/plan.ts";
import { computed } from "vue";
import { Modem } from "@/lib";
import { useExpirableStorage } from "@/lib/expirableStorage.ts";

export type Address = {
  id: number;
  full_address: string;
};

type Isp = {
  dont_transfer: boolean;
  can_continue: boolean;
  transfer_from: string;
  name_on_account: string;
  account_number: string;
};

export type Selected = {
  address: Address | null;
  product: Plan | null;
  modem: Modem | null;
  transfer: Isp | null;
};

export const useSignupStore = defineStore("signup", () => {
  const selected = useExpirableStorage<Selected>(
    "affinity_signup",
    {} as Selected,
  );
  const staticIp = useExpirableStorage("affinity_static_ip", false);
  const promoTlc = useExpirableStorage("affinity_promo_tlc", "");
  const lfc = useExpirableStorage("affinity_lfc", null as string | null);
  const onts = useExpirableStorage<Record<string, unknown> | null>(
    "affinity_onts",
    null,
  );
  const incentives = useExpirableStorage<object[]>("affinity_incentives", []);
  const utmSource = useExpirableStorage<string>("affinity_utm_source");

  function setAddress(address: Address | null) {
    selected.set({
      address,
      product: null,
      modem: null,
      transfer: null,
    });
  }

  function setProduct(product: Plan | null) {
    selected.set({
      ...(selected.get() as Selected),
      product,
    });
  }

  // function setModem(modem: Modem) {
  //   selected.value.modem = modem;
  // }

  function setTransfer(transfer: Isp) {
    selected.set({
      ...(selected.get() as Selected),
      transfer,
    });
  }

  function cleanStorage() {
    selected.remove();
    staticIp.remove();
    promoTlc.remove();
    lfc.remove();
    onts.remove();
    incentives.remove();
    utmSource.remove();
  }

  const isSelectedAddress = computed(
    () => !!(selected.get() as Selected).address?.id,
  );
  const isSelectedProduct = computed(
    () => !!(selected.get() as Selected).product,
  );
  const isSelectedModem = computed(() => !!(selected.get() as Selected).modem);
  const canContinue = computed(
    () =>
      isSelectedAddress.value &&
      isSelectedProduct.value &&
      isSelectedModem.value &&
      !!(selected.get() as Selected).transfer?.can_continue,
  );

  return {
    selected,
    isSelectedAddress,
    isSelectedProduct,
    isSelectedModem,
    canContinue,
    setAddress,
    setProduct,
    // setModem,
    setTransfer,
    cleanStorage,
    staticIp,
    promoTlc,
    lfc,
    onts,
    incentives,
    utmSource,
  };
});
